import './rating.css';

export default function Rating(){
  return {
    restrict: "E",
    scope:{
      rating: "=",
      ratingModel: '=',
      disabled: '='
    },
    template: require("./rating.html")
  }
}


// WEBPACK FOOTER //
// ./src/util/Rating.js